import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BtnModalTable } from '../../styled-components';

function ActionsField(props) {
  const [t] = useTranslation('ACTIVITIES');

  const { data, profile } = props;

  return (
    <React.Fragment>
      <div className="flex-check">
        <Link to={`/my-condos/${data._id}/agreements`}>
          <BtnModalTable type="button" className="mx-2 px-2">
            {t('INFO_CONTRACTS')}
          </BtnModalTable>
        </Link>
      </div>
    </React.Fragment>
  );
}

export default ActionsField;
